import type { ApplicationRulesFormValues } from './types';

export const getRefundPolicyText = (
  cancelReservationRule: ApplicationRulesFormValues['cancelReservation']
) => {
  if (
    cancelReservationRule &&
    cancelReservationRule.number &&
    cancelReservationRule.unit
  ) {
    return `活動開始前 ${cancelReservationRule.number} ${cancelReservationRule.unit}可取消預約，並全額退費。`;
  }
  return '';
};
